export function entranceLoader() {
	const COOKIE_NAME = 'ebtEntrance';
	const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year
	const prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	const hasCookie = () =>
		document.cookie.split('; ').some((c) => c.startsWith(COOKIE_NAME + '=1'));

	const setCookie = () =>
		(document.cookie = `${ COOKIE_NAME }=1; path=/; max-age=${ COOKIE_MAX_AGE }; samesite=lax`);

	const el = document.querySelector('.farlo-ebt-loader');
	if (!el) {
		document.body.classList.remove('show-preloader');
		return;
	}

	if (hasCookie() || prefersReduced) {
		setCookie();
		document.body.classList.remove('show-preloader');
		el.classList.add('farlo-ebt-loader--hidden');
		el.hidden = true;
		return;
	}

	const base = el.getAttribute('data-base') ||
    '/app/themes/Farlo/dist/assets/media/entrance/ebt-entrance-';
	const frames = Math.max(1, parseInt(el.getAttribute('data-frames') || '12', 10));
	const fps = Math.max(1, parseInt(el.getAttribute('data-fps') || '16', 10));

	const ext = document.documentElement.classList.contains('no-webp') ? 'png' : 'webp';

	el.hidden = false;
	const img = el.querySelector('.farlo-ebt-loader__frame') || document.createElement('img');
	if (!img.parentNode) {
		img.className = 'farlo-ebt-loader__frame';
		img.alt = '';
		img.decoding = 'async';
		el.appendChild(img);
	}

	// Preload frames
	const urls = Array.from({ length: frames }, (_, i) => `${ base }${ i + 1 }.${ ext }`);
	const preload = (src) =>
		new Promise((res) => {
			const im = new Image(); im.onload = im.onerror = () => res(src); im.src = src;
		});

	Promise.all(urls.map(preload)).then(() => {
		el.hidden = false;

		let idx = 0;
		const frameDuration = 1000 / fps;
		let last = performance.now();
		let rafId = null;

		img.src = urls[ 0 ];

		const tick = (now) => {
			if (now - last >= frameDuration) {
				last = now;
				idx += 1;
				if (idx < frames) {
					img.src = urls[ idx ];
				} else {
					setCookie();
					el.classList.add('farlo-ebt-loader--hidden');
					document.body.classList.remove('show-preloader');
					setTimeout(() => el.remove(), 300);
					if (rafId) {
						cancelAnimationFrame(rafId);
					}
					return;
				}
			}
			rafId = requestAnimationFrame(tick);
		};

		rafId = requestAnimationFrame(tick);

		document.addEventListener('visibilitychange', () => {
			if (document.hidden) {
				setCookie();
				el.classList.add('farlo-ebt-loader--hidden');
				document.body.classList.remove('show-preloader');
				setTimeout(() => el.remove(), 0);
				if (rafId) {
					cancelAnimationFrame(rafId);
				}
			}
		}, { once: true });
	});
}
